import { apiPost } from "./helpers/api";

export const createAcContactTag = (objectModel = '', attachmentId) => {
  return apiPost(
    `/attachments/${attachmentId}/active_campaign?object_model=${objectModel}`
  );
};
